import { ensureJourneyDb, listTable, writeAudit } from "../db";
import { notifyUser } from "./messaging/helpers";
import { publishSystemNotice } from "./systemNotices";
import { getFollowUp, setFollowUp } from "@hub";

export const GUIDED_HELP = [
  {
    id: "welcome",
    label: "Welcome to Messages",
    text: "Welcome. This thread is a quiet place for notes about this file — not a rush. Reply when you are ready.",
  },
  {
    id: "checklist",
    label: "Checklist reminder",
    text: "A gentle reminder: the checklist is a companion, not a race. Complete the next section when it feels settled, then we can look at it together.",
  },
  {
    id: "files",
    label: "File packet",
    text: "Documents for this file live in the File Packet. Add what you have; we can sort them on the desk.",
  },
  {
    id: "calendar",
    label: "Next appointment",
    text: "When you have a preferred time for the next conversation, add it on the calendar or reply here and we will hold the space.",
  },
];

export function broadcastAnnouncement({ title, body, from_name, actor_id }) {
  ensureJourneyDb();
  const notice = publishSystemNotice({
    kind: "feature",
    title,
    summary: body,
    body,
  });
  const users = listTable("users").filter((row) => row.status !== "inactive");
  users.forEach((user) => {
    notifyUser({
      user_id: user.id,
      type: "system",
      payload: { title, body, notice_id: notice.id, from_name: from_name || "Site admin" },
    });
  });
  writeAudit({
    user_id: actor_id || "admin-dev",
    action_type: "admin.broadcast",
    transaction_id: null,
    metadata: { notice_id: notice.id, recipients: users.length },
  });
  return { notice, recipients: users.length };
}

export function tagThreadFollowUp(threadId, { note, tagged = true, tagged_by } = {}) {
  return setFollowUp(threadId, { note, tagged, tagged_by });
}

export function followUpFor(threadId) {
  return getFollowUp(threadId);
}
